var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basicMain"},[_c('h2',[_vm._v("基本信息")]),_c('basicInformation',{on:{"toParent":_vm.getdata}}),_c('h2',[_vm._v("财务信息")]),(_vm.financialShow===true)?_c('financialInformation'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }